// @flow
import React from 'react'

type Props = {
  pathProps?: any,
  svgProps?: any,
}

export default (props: Props) => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" {...svgProps}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#617182"
          {...pathProps}
          fillRule="evenodd"
          d="M0 4.979l2.371 2.474.738-.681L1.877 5.5h4.077v-1H1.877l1.232-1.296-.738-.674L0 4.979zM4.924 0H10v10H4.924V8h1.015v1h3.046V1H5.939v1H4.924V0z"
        />
      </g>
    </svg>
  )
}
